module.exports = __webpack_public_path__ + "img/lv2_3_1.5843e9f7.png";